import api from "../../config/api";

const state = {
  randomAd: null,
  adsLoading: false,
  adsError: null,
};

const mutations = {
  setRandomAd(state, payload) {
    state.randomAd = payload;
  },
  setAdsLoading(state, payload) {
    state.adsLoading = payload;
  },
  setAdsError(state, payload) {
    state.adsError = payload;
  },
};

const actions = {
  async fetchRandomAd({ commit }, targetType = 'page') {
    commit('setAdsLoading', true);
    commit('setAdsError', null);
    try {
      const response = await api.get(`/ads/random?target_type=${targetType}`);
      const result = response?.data ?? null;
      commit('setRandomAd', result);
      return result;
    } catch (error) {
      console.error('Error fetching random ad:', error);
      commit('setAdsError', error?.message || 'Failed to load ad');
      commit('setRandomAd', null);
      throw error;
    } finally {
      commit('setAdsLoading', false);
    }
  },
};

const getters = {
  stRandomAd: (state) => state.randomAd,
  stAdsLoading: (state) => state.adsLoading,
  stAdsError: (state) => state.adsError,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
